module.exports = __webpack_public_path__ + "static/img/edit-geometry.0e468896.svg";